// utils/deliveryLocation.ts
export interface Location {
  address?: string;
  house?: string;
  neighborhood?: string;
  latitude?: number;
  longitude?: number;
  id?: string;
  isDefault?: boolean;
}

export const buildDeliveryLocation = (locations: Location[]): Location | null => {
  if (!locations || locations.length === 0) return null;

  // Buscar ubicación por defecto
  const defaultLoc = locations.find((loc) => loc.isDefault) || locations[0];

  return {
    address: defaultLoc.address ?? "",
    house: defaultLoc.house ?? "",
    neighborhood: defaultLoc.neighborhood ?? "",
    latitude: defaultLoc.latitude ?? 0,
    longitude: defaultLoc.longitude ?? 0,
  };
};
